export const TITILLIUM = "Titillium Web";
export const LATO = "Lato";

export const COLOR_WHITE = "#fff";
export const COLOR_BLACK = "#000";

export const COLOR_GRAY_300 = "#d1d5db";

export const COLOR_BLACK_700 = "#404040";
export const COLOR_BLACK_800 = "#262626";
export const COLOR_BLACK_900 = "#171717";

export const COLOR_RED_600 = "#dc2626";

export const COLOR_GREEN_500 = "#22c55e";

export const COLOR_BLUE_300 = "#93c5fd";

export const COLOR_YELLOW_500 = "#eab308";

export const COLOR_VIOLET_400 = "#a78bfa";
